(() => {
  const storageKey = 'theme-mode';
  const root = document.documentElement;
  const toggleSelector = '[data-theme-mode-toggle]';
  const themeColor = document.querySelector('meta[name="theme-color"]');
  const modeStorage = (() => {
    try {
      localStorage.removeItem(storageKey);
      return window.sessionStorage;
    } catch (error) {
      return null;
    }
  })();

  const currentMode = () => (root.dataset.themeMode === 'light' ? 'light' : 'dark');

  const updateControls = (mode) => {
    document.querySelectorAll(toggleSelector).forEach((toggle) => {
      const nextLabel =
        mode === 'light' ? toggle.dataset.themeModeLabelDark : toggle.dataset.themeModeLabelLight;

      if (nextLabel) {
        toggle.setAttribute('aria-label', nextLabel);
      }

      toggle.setAttribute('aria-pressed', mode === 'light' ? 'true' : 'false');
    });
  };

  const applyMode = (mode) => {
    root.dataset.themeMode = mode;
    root.style.colorScheme = mode;

    if (themeColor) {
      themeColor.setAttribute('content', mode === 'light' ? '#ffffff' : '#060d15');
    }

    try {
      if (modeStorage) {
        modeStorage.setItem(storageKey, mode);
      }
    } catch (error) {
      return;
    }

    updateControls(mode);
  };

  const setMode = (mode, animate = true) => {
    const nextMode = mode === 'light' ? 'light' : 'dark';

    if (animate && document.startViewTransition) {
      document.startViewTransition(() => applyMode(nextMode));
      return;
    }

    applyMode(nextMode);
  };

  document.addEventListener('DOMContentLoaded', () => {
    setMode(currentMode(), false);

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) {
        return;
      }

      const toggle = event.target.closest(toggleSelector);

      if (!toggle) {
        return;
      }

      event.preventDefault();
      setMode(currentMode() === 'light' ? 'dark' : 'light');
    });
  });
})();
